import tw, { styled, theme } from 'twin.macro';

import { Props, Type, Variation } from './Badge';

type StyledBadgeProps = Pick<Props, 'variation' | 'type' | 'rounded' | 'numeric'>;

const getVariation = (variation?: Variation, type?: Type) => {
	switch (variation) {
		case 'primary':
			return type === 'subtle' ? tw`bg-indigo-100 text-indigo-900` : tw`text-white bg-indigo-500`;
		case 'info':
			return type === 'subtle' ? tw`bg-blue-100 text-blue-900` : tw`text-white bg-blue-500`;
		case 'warning':
			return type === 'subtle' ? tw`bg-yellow-100 text-yellow-900` : tw`text-white bg-yellow-500`;
		case 'error':
			return type === 'subtle' ? tw`bg-red-100 text-red-900` : tw`text-white bg-red-500`;
		case 'success':
			return type === 'subtle' ? tw`bg-green-100 text-green-900` : tw`text-white bg-green-600`;
		case 'default':
		default:
			return type === 'subtle' ? tw`bg-gray-100 text-gray-700` : tw`text-white bg-gray-500`;
	}
};

export const StyledBadge = styled.span<StyledBadgeProps>(({ variation, type, rounded, numeric }) => [
	tw`font-normal px-1.5 py-1 text-xs leading-4 rounded inline-flex items-center justify-center whitespace-nowrap`,
	getVariation(variation, type),
	rounded && tw`rounded-full min-w-[24px] h-[24px]`,
	numeric && tw`tabular-nums`,
]);

export const getIconColor = (variation?: Variation, type?: Type): string => {
	if (type === 'loud') return theme`colors.white`;

	switch (variation) {
		case 'primary':
			return theme`colors.indigo.500`;
		case 'info':
			return theme`colors.blue.500`;
		case 'warning':
			return theme`colors.yellow.900`;
		case 'error':
			return theme`colors.red.500`;
		case 'success':
			return theme`colors.green.500`;
		default:
			return theme`colors.gray.700`;
	}
};
